import nxModule from 'nxModule';
import StatusBasedService from "./statusBasedService";

nxModule.factory('recentlyApprovedCommandService', (statusService) =>
  new StatusBasedService({
    property: 'recentlyApprovedCommand',
    statusService: statusService,
    optional: true
  }));